import { ReactComponent as AnthropicBadge1Logo } from '../../assets/anthropic_badge_1.svg'
import { ReactComponent as AnthropicBadge2Logo } from '../../assets/anthropic_badge_2.svg'
import "./ProfessionalDevelopment.scss";

function ProfessionalDevelopment() {
  return (
    <>
      <h2>Professional Development</h2>
      <div className="professional-development">
        <div className="professional-development__item">
          <a
            className="professional-development__logo"
            href="https://academy.claude.com/verify/ffcabe30e7630b53b630a41e80c2a332"
            target="_blank"
            rel="noopener noreferrer"
          >
            <AnthropicBadge1Logo />
          </a>
          <div className="professional-development__info">
            <p className="professional-development__info__title">
              Building with the Claude API
            </p>
            <p>Claude Academy</p>
            <p className="professional-development__date">Issued September 4, 2026</p>
          </div>
        </div>
        <div className="professional-development__item">
          <a
            className="professional-development__logo"
            href="https://academy.claude.com/verify/4a664e83a3a4fe0400804f87347dd723"
            target="_blank"
            rel="noopener noreferrer"
          >
            <AnthropicBadge2Logo />
          </a>
          <div className="professional-development__info">
            <p className="professional-development__info__title">
              Claude Code in Action
            </p>
            <p>Claude Academy</p>
            <p className="professional-development__date">Issued March 8, 2026</p>
          </div>
        </div>
      </div>
    </>
  );
}

export { ProfessionalDevelopment };
